export default {
  detail: (state) => {
    return JSON.parse(JSON.stringify(state.detail));
  }
};
